export default __webpack_public_path__ + "static/media/board.min.b4b1ccf9.png";